import { CreditCard, Wallet, FileCheck2, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Wallet, title: "Pagamento al Ritiro", desc: "Paga in contanti o con carta direttamente al desk quando ritiri le chiavi. Nessun anticipo." },
  { icon: CreditCard, title: "Pagamento Online", desc: "Salda subito con carta di credito o debito per velocizzare il ritiro." },
  { icon: FileCheck2, title: "Documenti dal Telefono", desc: "Carica patente e carta d'identità scattando una foto dal tuo smartphone." },
  { icon: ShieldCheck, title: "Cauzione Trasparente", desc: "Importo della cauzione sempre chiaro, restituito per intero a fine noleggio." },
];

export const RentalFeatures = () => (
  <section className="max-w-7xl mx-auto px-6 pb-20" data-testid="rental-features">
    <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-3">Come funziona</div>
    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase mb-8">Noleggiare con noi è semplice</h2>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {FEATURES.map((f, i) => (
        <div key={f.title} className="p-6 rounded-2xl bg-[#181A22] border border-white/10 fade-up" style={{ animationDelay: `${i * 80}ms` }}>
          <div className="w-12 h-12 rounded-xl bg-[#E63946]/15 flex items-center justify-center mb-5">
            <f.icon className="w-6 h-6 text-[#E63946]" />
          </div>
          <h3 className="font-display font-bold text-lg mb-2">{f.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
